<template>
  <div class="ratings-container">
    <Rating
      v-for="(item, index) in ratingList"
      :key="index"
      :time="item.submit_time"
      :rate="getRate(item.total_rate)"
      :comment="item.comment"
      :name="item.hm_name"
      :status="item.status"
    ></Rating>
    <div v-if="totalAvgRate" class="total-score">{{ totalAvgRate }}</div>
  </div>
</template>

<script>
import Rating from './rating.vue'

export default {
  components: {
    Rating
  },
  props: {
    ratingList: {
      required: true
    },
    totalAvgRate: {
      type: Number
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    getRate (rate) {
      return Number(rate) / 100 * 6
    }
  }
}
</script>

<style lang="scss" scoped>
.ratings-container {
  position: relative;
  margin-top: 36px;
  margin-right: 35px;

  .total-score {
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(50%, -50%);
    width: 70px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    border: 2px solid #0096cc;
    color: #0096cc;
    border-radius: 50%;
    background-color: #fff;
  }
}
</style>
